import React, { useState, forwardRef, useRef, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { StyledInput, InputWrapper, ToggleVisibility } from "./styles";
import { set } from "react-hook-form";
import { createStyledIcon } from "utils/iconUtils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  $halfWidth?: boolean;
}

const EyeIcon = createStyledIcon(FaEye);
const EyeSlashIcon = createStyledIcon(FaEyeSlash);

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ type, $halfWidth, ...props }, ref) => {
    const [hasMounted, setHasMounted] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = type === "password";
    const inputType = isPassword && showPassword ? "text" : type;

    const localRef = useRef<HTMLInputElement>(
      null
    ) as React.MutableRefObject<HTMLInputElement | null>;

    // Keep both react-hook-form ref and localRef
    const setRefs = (el: HTMLInputElement) => {
      if (typeof ref === "function") ref(el);
      else if (ref)
        (ref as React.MutableRefObject<HTMLInputElement>).current = el;

      localRef.current = el;
    };

    useEffect(() => {
      if (!hasMounted) {
        setHasMounted(true);
        return;
      }

      if (isPassword && localRef.current) {
        const len = localRef.current.value.length;
        setTimeout(() => {
          if (localRef.current) {
            localRef.current.focus();
            localRef.current.setSelectionRange(len, len);
          }
        }, 0);
      }
    }, [showPassword]);

    return (
      <InputWrapper $halfWidth={$halfWidth}>
        <StyledInput ref={setRefs} type={inputType} {...props} />
        {isPassword && (
          <ToggleVisibility
            type="button"
            onPointerDown={(e) => e.preventDefault()}
            onClick={() => setShowPassword((prev) => !prev)}
            tabIndex={-1}
            aria-label="Toggle password visibility"
          >
            {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
          </ToggleVisibility>
        )}
      </InputWrapper>
    );
  }
);

export default Input;
